import {SignInSource} from "./SignInSource";

export class MockSignInSource extends SignInSource {
    constructor() {
        super();
    }
}